"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLoggerInjector = exports.tryToLog = exports.ResponseFeature = exports.RequestFeature = exports.ResponseErrorFeature = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const General = require("../general");
const debugContext = General.initContext();
let debugLoggerInjector = null;
exports.ResponseErrorFeature = General.registerContext(debugContext);
exports.RequestFeature = General.registerContext(debugContext);
exports.ResponseFeature = General.registerContext(debugContext);
const tryToLog = (fn) => {
    try {
        const log = fn();
        // 如果设置了自定义的 debugLogger，则优先使用设置的
        if (debugLoggerInjector !== null) {
            debugLoggerInjector(log);
            return;
        }
        console.debug(log);
    }
    catch (e) {
        console.error(e);
    }
};
exports.tryToLog = tryToLog;
/**
 * 设置自定义的 debug logger
 * @param logger 自定义的 debug logger
 */
const setLoggerInjector = (logger) => {
    debugLoggerInjector = logger;
};
exports.setLoggerInjector = setLoggerInjector;
//# sourceMappingURL=index.js.map